import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
var _excluded = ["children", "className", "active", "disabled"];
var _dec, _class;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import bodyClick from '../../decorators/bodyClick';
import Icon from '../../components/Icon';
import IconSvg from '../../components/IconSvg';
import Link from '../../components/Link';
import './styles.sass';

/**
 * How long does it take a dropdown to animate?
 * That sounds like a lightbulb joke, hah!
 * @type {Number}
 */
var TRANSITION_DURATION = 200;

/**
 * The dropdown component itself. It needs a button
 * which will be wrapped so the dropdown can be displayed relative to it.
 *
 * When `isOpen` is undefined, the component is uncontrolled and manages
 * it's own state. If not, then it's controlled.
 */
export var Dropdown = (_dec = bodyClick(), _dec(_class = /*#__PURE__*/function (_Component) {
  /**
   * Constructor.
   */
  function Dropdown() {
    var _this;
    _classCallCheck(this, Dropdown);
    _this = _callSuper(this, Dropdown, arguments);
    /**
     * Initial state.
     */
    _this.state = {
      isOpen: false
    };
    /**
     * When the button is clicked (that is, when the wrapping span is clicked),
     * if controlled, trigger the callback. If not, toggles internal `isOpen` state.
     */
    _this.onButtonClick = function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (!_this.isControlled()) {
        _this.toggleDropdown();
      } else {
        if (_this.props.onButtonClick) {
          _this.props.onButtonClick();
        }
      }
    };
    _this.toggleDropdown = _this.toggleDropdown.bind(_this);
    return _this;
  }

  /**
   * Toggles the internal `isOpen` state.
   */
  _inherits(Dropdown, _Component);
  return _createClass(Dropdown, [{
    key: "toggleDropdown",
    value: function toggleDropdown() {
      this.setState({
        isOpen: !this.state.isOpen
      });
    }
  }, {
    key: "isControlled",
    value:
    /**
     * Determines if this dropdown is controlled.
     */
    function isControlled() {
      return this.props.isOpen !== undefined;
    }

    /**
     * If configured, dismisses the dropdown.
     */
  }, {
    key: "onBodyClick",
    value: function onBodyClick(e) {
      if (this.togglerButton) {
        var domNode = this.togglerButton;
        if (domNode && domNode.contains(e.target)) {
          return;
        }
      }
      if (this.props.persist && this.dropdownContentNode) {
        var _domNode = this.dropdownContentNode;
        if (_domNode && _domNode.contains(e.target)) {
          return;
        }
      }
      if (this.isControlled()) {
        if (this.props.onRequestClose && this.props.isOpen) {
          this.props.onRequestClose();
        }
        return;
      }
      if (this.state.isOpen && this.props.autoDismiss) {
        this.toggleDropdown();
      }
    }

    /**
     * Renders the dropdown.
     */
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        button = _this$props.button,
        children = _this$props.children,
        className = _this$props.className,
        stretch = _this$props.stretch,
        position = _this$props.position,
        maxHeight = _this$props.maxHeight,
        topOffset = _this$props.topOffset,
        noPadding = _this$props.noPadding,
        isOpen = _this$props.isOpen,
        centerDropdown = _this$props.centerDropdown;
      var dropdownIsOpen = !this.isControlled() ? this.state.isOpen : isOpen;
      return /*#__PURE__*/React.createElement("div", {
        className: cx('Dropdown', stretch && 'Dropdown--stretch', className)
      }, button && (typeof button === 'function' ? button({
        innerRef: function innerRef(n) {
          _this2.togglerButton = n;
        },
        onClick: this.onButtonClick
      }) : /*#__PURE__*/React.createElement("span", {
        onClick: this.onButtonClick,
        ref: function ref(n) {
          _this2.togglerButton = n;
        }
      }, button)), /*#__PURE__*/React.createElement(TransitionGroup, null, dropdownIsOpen && /*#__PURE__*/React.createElement(CSSTransition, {
        timeout: TRANSITION_DURATION,
        appear: true,
        classNames: {
          enter: 'DropdownAnimation-enter',
          appear: 'DropdownAnimation-enter',
          exit: 'DropdownAnimation-leave'
        }
      }, /*#__PURE__*/React.createElement("ul", {
        className: cx('DropdownContent', position === null || position === void 0 ? void 0 : position.split(' '), noPadding && 'DropdownContent--noPadding', centerDropdown && 'center-dropdown'),
        style: {
          maxHeight: maxHeight,
          marginTop: topOffset
        },
        ref: function ref(n) {
          _this2.dropdownContentNode = n;
        }
      }, typeof children === 'function' ? children({
        toggle: this.toggleDropdown
      }) : children))));
    }
  }]);
}(Component)) || _class);
Dropdown.defaultProps = {
  position: 'left',
  autoDismiss: true,
  topOffset: 5,
  maxHeight: 580,
  noPadding: false
};
Dropdown.propTypes = {
  className: PropTypes.string,
  position: PropTypes.string,
  button: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  isOpen: PropTypes.bool,
  stretch: PropTypes.bool,
  autoDismiss: PropTypes.bool,
  noPadding: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  onButtonClick: PropTypes.func,
  onRequestClose: PropTypes.func,
  maxHeight: PropTypes.number,
  topOffset: PropTypes.number,
  persist: PropTypes.bool
};

/**
 * Used by `DropdownItem`.
 */
export var DropdownItemContainer = function DropdownItemContainer(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("li", {
    className: "DropdownItemContainer"
  }, children);
};
DropdownItemContainer.propTypes = {
  children: PropTypes.node.isRequired
};

/**
 * A regular dropdown item.
 */
export var DropdownItem = function DropdownItem(_ref2) {
  var children = _ref2.children,
    className = _ref2.className,
    active = _ref2.active,
    disabled = _ref2.disabled,
    other = _objectWithoutProperties(_ref2, _excluded);
  return /*#__PURE__*/React.createElement(DropdownItemContainer, null, /*#__PURE__*/React.createElement(Link, _extends({
    className: cx('DropdownItem', className, active && 'is-active', disabled && 'is-disabled'),
    disabled: disabled
  }, other), children));
};
DropdownItem.propTypes = {
  className: PropTypes.string,
  active: PropTypes.bool,
  children: PropTypes.node
};

/**
 * A dropdown item icon. Nice.
 */
export var DropdownItemIcon = function DropdownItemIcon(_ref3) {
  var name = _ref3.name,
    material = _ref3.material,
    children = _ref3.children;
  return /*#__PURE__*/React.createElement("span", {
    className: "DropdownItemIcon"
  }, name && /*#__PURE__*/React.createElement(Icon, {
    name: name,
    className: "DropDownItemIcon__icon",
    material: material
  }), children);
};
DropdownItemIcon.propTypes = {
  name: PropTypes.string,
  material: PropTypes.bool,
  children: PropTypes.node
};

/**
 * A dropdown item icon svg
 */
export var DropdownItemIconSvg = function DropdownItemIconSvg(_ref4) {
  var children = _ref4.children;
  return /*#__PURE__*/React.createElement("span", {
    className: "DropdownItemIcon"
  }, /*#__PURE__*/React.createElement(IconSvg, {
    size: 18
  }, children));
};
DropdownItemIconSvg.propTypes = {
  children: PropTypes.node
};
export var DropdownSectionTitle = function DropdownSectionTitle(_ref5) {
  var children = _ref5.children,
    className = _ref5.className;
  return /*#__PURE__*/React.createElement("p", {
    className: cx('DropdownSectionTitle', className)
  }, children);
};
DropdownSectionTitle.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};
export var DropdownSection = function DropdownSection(_ref6) {
  var children = _ref6.children,
    className = _ref6.className;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('DropdownSection', className)
  }, children);
};
DropdownSection.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};
//# sourceMappingURL=index.js.map
